module.exports = __webpack_public_path__ + "static/ueberMichIllustration-f86615d9e09fea80adf16ae9d739f405.jpg";